import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';

export default async (url, accessToken) => {
  const connection = new HubConnectionBuilder()
    .withUrl(url, {
      accessTokenFactory: () => accessToken,
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets
    })
    .withAutomaticReconnect([0, 1000, 2000, 5000, 10000, 10000, 10000, 20000])
    .build();
  await connection.start();
  return connection;
};
